import { useState } from 'react';
import { FaTrophy, FaMedal, FaStar, FaGraduationCap, FaAward, FaTimes, FaSearchPlus, FaProjectDiagram, FaCertificate, FaBook } from 'react-icons/fa';
import './Achievements.css';

import imgPL from '../achievements/PL.jpg';
import imgDL1 from '../achievements/DL 1.jpg';
import imgDL2 from '../achievements/DL 2.jpg';
import imgDL3 from '../achievements/DL 3.jpg';
import imgDL4 from '../achievements/DL 4.jpg';
import imgWithHonors from '../achievements/With Honors.jpeg';
import imgSHS from '../achievements/SHS.jpeg';
import imgElem from '../achievements/elem recog.jpg';
import imgSHSProject from '../projects/shs project.png';
import imgBestPic from '../projects/best pic.jpg';
import img2ndPlace from '../certs/2nd place.jpeg';

function Achievements() {
  const [selectedImage, setSelectedImage] = useState(null);

  const sections = [
    {
      label: "Academic Excellence",
      items: [
        { id: 'pl', title: "President's Lister", sub: 'FAITH Colleges', date: '2023-24', desc: 'Achieved the highest academic distinction for the 1st semester of my first year.', image: imgPL, icon: <FaStar />, color: '#d4a017', pos: 'center 75%' },
        { id: 'dl4', title: "Dean's Lister", sub: 'FAITH Colleges', date: '2025-26', desc: 'Maintained excellent grades and recognition in my 3rd year, 1st semester.', image: imgDL4, icon: <FaTrophy />, color: '#1f4788', pos: 'center 35%' },
        { id: 'dl3', title: "Dean's Lister", sub: 'FAITH Colleges', date: '2024-25', desc: 'Recognized for consistent academic performance in my 2nd year, 2nd semester.', image: imgDL3, icon: <FaTrophy />, color: '#1f4788', pos: 'center 35%' },
        { id: 'dl2', title: "Dean's Lister", sub: 'FAITH Colleges', date: '2024-25', desc: 'Earned a spot on the Dean’s List during my 2nd year, 1st semester.', image: imgDL2, icon: <FaTrophy />, color: '#5ba3d0', pos: 'center 35%' },
        { id: 'dl1', title: "Dean's Lister", sub: 'FAITH Colleges', date: '2023-24', desc: 'Started my collegiate journey with academic honors in the 2nd semester of 1st year.', image: imgDL1, icon: <FaTrophy />, color: '#5ba3d0', pos: 'center 35%' },
      ]
    },
    {
      label: "Technical & Research Awards",
      items: [
        { id: 'best', title: "Best in Research", sub: "Technical Prototype", date: "2025", desc: 'Awarded for outstanding technical execution and innovative research prototype.', image: imgBestPic, icon: <FaProjectDiagram />, color: '#d4a017', pos: 'center 50%' },
        { id: 'journal', title: "2nd Place: Journal", sub: "Academic Research", date: "2024", desc: 'Recognized for excellence in journal-based research presentation and defense.', image: img2ndPlace, icon: <FaAward />, color: '#1f4788', pos: 'center 35%' },
        { id: 'web', title: "Website Project", sub: "Development", date: "2022", desc: 'Successfully developed and deployed a multi-page website as a major SHS project.', image: imgSHSProject, icon: <FaProjectDiagram />, color: '#5ba3d0', pos: 'center center' },
      ]
    },
    {
      label: "Education Milestones",
      items: [
        { id: 'shs', title: "With Honors", sub: 'STEM Strand', date: '2021-23', desc: 'Graduated from Senior High School with honors recognition for academic consistency.', image: imgSHS, icon: <FaGraduationCap />, color: '#1f4788', pos: 'center 80%' },
        { id: 'jhs', title: "With Honors", sub: 'Junior High', date: '2017-21', desc: 'Consistently achieved honors throughout my four years of junior high school.', image: imgWithHonors, icon: <FaMedal />, color: '#87bfff', pos: 'center 75%' },
        { id: 'elem', title: "With Honors", sub: 'Elementary', date: '2016-17', desc: 'Awarded honors recognition during my elementary graduation ceremony.', image: imgElem, icon: <FaAward />, color: '#5ba3d0', pos: 'center 60%' },
      ]
    }
  ];

  return (
    <div className="achievements-clean-page">
      <div className="achievements-header visible">
        <div className="header-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="achievements-header-content">
          <h1 className="page-title">ACADEMIC ACHIEVEMENTS</h1>
          <p className="page-subtitle">A professional record of my academic excellence and technical recognitions</p>
        </div>
      </div>

      <div className="clean-grid-container">
        {sections.map((section, sIdx) => (
          <div key={sIdx} className="clean-section">
            <div className="clean-section-header">
              <h2 className="clean-section-title">{section.label}</h2>
              <div className="clean-section-line"></div>
            </div>
            
            <div className="clean-grid">
              {section.items.map((item) => (
                <div key={item.id} className="clean-card">
                  <div className="clean-card-visual" onClick={() => setSelectedImage({ url: item.image, title: item.title, pos: item.pos })}>
                    <img src={item.image} alt={item.title} style={{ objectPosition: item.pos || 'center top' }} />
                    <div className="clean-zoom-overlay"><FaSearchPlus /></div>
                  </div>
                  <div className="clean-card-content">
                    <div className="clean-card-top">
                      <span className="clean-card-date">{item.date}</span>
                      <div className="clean-card-icon" style={{ color: item.color }}>{item.icon}</div>
                    </div>
                    <h3 className="clean-card-title">{item.title}</h3>
                    <h4 className="clean-card-sub">{item.sub}</h4>
                    <p className="clean-card-desc">{item.desc}</p>
                  </div>
                  <div className="clean-card-accent" style={{ background: item.color }}></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="achieve-modal-overlay active" onClick={() => setSelectedImage(null)}>
          <div className="achieve-modal pop-in" onClick={(e) => e.stopPropagation()}>
            <button className="achieve-modal-close" onClick={() => setSelectedImage(null)}><FaTimes /></button>
            <div className="achieve-modal-image-container">
              <img src={selectedImage.url} alt={selectedImage.title} className="achieve-modal-image" />
            </div>
            <div className="achieve-modal-caption">{selectedImage.title}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Achievements;
